import { Platform, ViewStyle } from 'react-native';

/**
 * Creates cross-platform shadow styles
 * Uses boxShadow for web and shadow* props for native
 */
export function createShadow(
  offsetX: number = 0,
  offsetY: number = 4,
  blurRadius: number = 20,
  color: string = '#000',
  opacity: number = 0.1
): ViewStyle {
  if (Platform.OS === 'web') {
    // Convert color and opacity to rgba for web
    const rgba = hexToRgba(color, opacity);
    return {
      // @ts-ignore - boxShadow is valid for web
      boxShadow: `${offsetX}px ${offsetY}px ${blurRadius}px ${rgba}`,
    };
  }

  // Native shadow props
  return {
    shadowColor: color,
    shadowOffset: {
      width: offsetX,
      height: offsetY,
    },
    shadowOpacity: opacity,
    shadowRadius: blurRadius,
    elevation: Math.ceil(blurRadius / 2), // Android elevation approximation
  };
}

/**
 * Common shadow presets
 */
export const shadows = {
  /** Small shadow for cards and buttons */
  sm: createShadow(0, 1, 3, '#000', 0.1),
  /** Medium shadow for elevated cards */
  md: createShadow(0, 4, 6, '#000', 0.1),
  /** Large shadow for modals and dropdowns */
  lg: createShadow(0, 4, 20, '#000', 0.1),
  /** Extra large shadow for floating elements */
  xl: createShadow(0, 10, 40, '#000', 0.15),
  /** No shadow */
  none: {},
};

/**
 * Convert hex color to rgba string
 */
function hexToRgba(hex: string, opacity: number): string {
  // Remove # if present
  hex = hex.replace('#', '');

  // Parse hex values
  let r: number, g: number, b: number;

  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else {
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  }

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
